import types from "./types";
import { combineReducers } from 'redux'

const isLoading = (state = true, action) => {
  switch (action.type) {
    case types.FINISH_USER_DETAILS_LOADING: {
      return false
    }
    case types.BEGIN_USER_DETAILS_LOADING: {
      return true
    }
    default: {
      return state
    }
  }
}

const user = (state = {}, action) => {
  switch (action.type) {
    case types.RECEIVE_USER_DETAILS: {
      return action.payload
    }
    default: {
      return state
    }
  }
}

export default combineReducers({
  isLoading,
  user
});
